import { useTranslation } from "react-i18next";
import SearchInput from "../search-input";
import { useDilemmasFilterStore } from "@/features/dilemmas/stores";
import { Button } from "../ui/button";
import { PlusIcon } from "lucide-react";
import { ROUTES } from "@/constants/routes";
import { NavLink } from "react-router-dom";
import DilemmasFilterComponent from "@/features/dilemmas/components/filter-component";
import ImportFromExcelDialog from "@/features/dilemmas/components/import/import-from-excel-dialog";

const DilemmasPageHeader = () => {
  const { searchValue, setSearchValue } = useDilemmasFilterStore();
  const { t } = useTranslation();
  return (
    <div className="flex-1 flex items-center justify-between gap-4 w-full">
      <h1 className="lg:text-lg">{t("titles.dashboard.dilemmas.list")}</h1>
      <div className="flex items-center gap-2 flex-1 justify-end">
        <SearchInput
          value={searchValue ?? ""}
          onChange={setSearchValue}
          className="max-w-72 hidden lg:flex"
        />
        <div className="hidden lg:block">
          <DilemmasFilterComponent />
        </div>
        <ImportFromExcelDialog />
        <NavLink to={ROUTES.DILEMMA_CREATE}>
          <Button>
            <PlusIcon />
            <span className="hidden md:inline">
              {t("modules.dilemmas.keys.add_dilemma")}
            </span>
          </Button>
        </NavLink>
      </div>
    </div>
  );
};

export default DilemmasPageHeader;
